module.exports = __webpack_public_path__ + "static/media/forwardhead_mild_left.e4e80a21.png";